import jwt from 'jwt-simple';

export let roleInfo = JSON.parse(localStorage.getItem('userInfo'));
export let roleName = localStorage.getItem('roleName');
export let globalData = {
    userInfo: {},
    currentDepId: 0,
    currentCaseId: 0,
    isCollision: false,
    dragData: null,
    toastMsg: "Please fill in the complete information",
    countryCode: "",
    infoDate: new Date(),
    haveNonage: true,
    spouseInfo: {},
    clientInfo: {},
    singleArr: [],
    dataINFO: {},
    sendEmail: false,
    sendEmailData: {},
    pListData: [],
}
export const defaultPageSize = 25;
export const ADD = 0;
export const VIEW = 1;
export const EDIT = 2;
export const ERR = "err";
export const TEXT = "text";
export const CLIENT = "client";
export const SPOUSE = "spouse";
export const CHILD = "child";
export const NORMAL = "normal";
export const FINAL = "final";
export const DRAFT = "draft";
export const MANUAL = "manual_editing";
export const EMAIL = "email_editing";
export const ONGOING = "ongoing";
export const COMPLETED = "completed";
export const DISABLED = "disabled";
export const ROLES = {
    admin: "admin",
    deptManager: "dept_manager",
    billingManger: "billing_manager",
    teamLeader: "team_leader",
    staff: "staff"
}
export const isRole = (roleName) => {
    if (!roleInfo) {
        window.location.href = '/';
        return false;
    }
    const roles = roleInfo.identity.role;
    for (let role of roles) {
        if (role === roleName) {
            return true;
        }
    }
    return false;
}
export const roleStr = () => {
    if (isRole(ROLES.admin)) {
        return "admin";
    } else if (isRole(ROLES.deptManager)) {
        return "department";
    } else if (isRole(ROLES.staff)) {
        return "staff";
    } else if (isRole(ROLES.teamLeader)) {
        return "team";
    }
}
//1:admin 2:manager 3:leader 4:user
export const roleAnalysis = (token) => {
    let secret = process.env.REACT_APP_PUBLIC_KEY
    let decoded = jwt.decode(token, secret, true, 'RS256');
    roleInfo = decoded
    const exp = decoded.exp;
    const now = Date.parse(new Date()) / 1000;
    localStorage.setItem('userInfo', JSON.stringify(decoded));
    if (exp > now - 60) {
        return decoded;
        // return null;
    } else {
        return null;
    }
}
export const invoiceEmailTemplate = (client = "Client") => {
    if (client === null || client === "") {
        client = "Client"
    }
    return `<p>Dear ${client},</p>` +
        "<p>I hope that this email finds you well.  I have attached the bill for recent legal services.</p>" +
        "<p style='margin: 0;'>Best Regards,</p>" +
        "<p style='margin: 0;'>MT LAW</p>";
};

